import { polygonArea } from './layout.js';
import { DUNGEON_ROOM_ROLES, } from './types.js';
/**
 * Layout metrics (AD-404 §8): chamber area spread, choke count and compactness
 * (Σ chamber area / bounding area — "condensed", measured). Millimetre/3-dp
 * canonical, as `layout-determinism` requires of every layout number.
 */
export function analyzeDungeonLayout(chambers, corridors, bounds) {
    const areas = chambers.map((chamber) => Math.abs(polygonArea(chamber.outline)));
    const boundingArea = (bounds.maxX - bounds.minX) * (bounds.maxZ - bounds.minZ);
    const total = areas.reduce((sum, area) => sum + area, 0);
    return {
        chamberAreaMin: Number(Math.min(...areas).toFixed(3)),
        chamberAreaMax: Number(Math.max(...areas).toFixed(3)),
        chokeCount: corridors.filter((corridor) => corridor.segments.some((segment) => segment.kind === 'choke')).length,
        compactness: boundingArea > 0 ? Number((total / boundingArea).toFixed(3)) : 0,
    };
}
export function analyzeDungeonPlan(rooms, connections, criticalPathRoomIds) {
    const roleCounts = Object.fromEntries(DUNGEON_ROOM_ROLES.map((role) => [role, 0]));
    let ordinaryEncounterCount = 0;
    let bossCount = 0;
    let totalPlannedThreat = 0;
    let totalEnemyCount = 0;
    const enemyIds = new Set();
    for (const room of rooms) {
        roleCounts[room.role] += 1;
        const encounter = room.encounter;
        if (!encounter)
            continue;
        if (encounter.kind === 'boss')
            bossCount += 1;
        else
            ordinaryEncounterCount += 1;
        totalPlannedThreat += encounter.plannedThreat;
        for (const member of encounter.members) {
            enemyIds.add(member.enemyId);
            totalEnemyCount += member.count;
        }
    }
    return {
        roomCount: rooms.length,
        edgeCount: connections.length,
        loopCount: Math.max(0, connections.length - rooms.length + 1),
        criticalPathLength: criticalPathRoomIds.length,
        ordinaryEncounterCount,
        bossCount,
        totalPlannedThreat: Number(totalPlannedThreat.toFixed(3)),
        uniqueEnemyCount: enemyIds.size,
        repeatedEnemyRatio: totalEnemyCount === 0
            ? 0
            : Number(((totalEnemyCount - enemyIds.size) / totalEnemyCount).toFixed(3)),
        roleCounts,
    };
}
//# sourceMappingURL=analyze.js.map